import React from 'react'
import Banners from '../../../Components/Banner/Banners'
import ResetForm from '../../../Components/Auth/ResetForm'


const ChangePassword = () => {
    return (
        <>
            <Banners name='Reset Password' />

            <div class="container">
                <div class="row">
                    <div class="col-md-6 offset-md-3">
                        <ResetForm />
                    </div>

                </div>
            </div>
        </>
    )
}

export default ChangePassword